import React from 'react';
import { Modal } from '../ui/Modal.js';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';
import Spinner from '../Spinner.js';

const OrderCancelConfirmationModal = ({ isOpen, onClose, onCancelOrder, isCancelling }) => {
  const { language } = useDataContext();

  return (
    <Modal isOpen={isOpen} onClose={onClose} staticBackdrop contentClassName="max-w-[400px]">
      <div className="pt-8 px-6 pb-6">
        <div className="text-center mb-6">
          <div
            className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_4px_16px_rgba(239,68,68,0.3)]"
            style={{ background: 'linear-gradient(135deg, #f59e0b, #ef4444)' }}
          >
            <span className="text-3xl">⚠️</span>
          </div>
          <h3 className="text-xl font-bold text-[#1a1a1a] mb-1.5">
            {translations[language]?.restaurant_menu_cancel_order_confirmation}
          </h3>
        </div>

        <div className="flex flex-col gap-2.5">
          <button
            onClick={onCancelOrder}
            disabled={isCancelling}
            className={`w-full py-[14px] text-[15px] font-semibold bg-red-500 hover:bg-red-600 text-white border-none rounded-xl cursor-pointer transition-colors duration-200 flex items-center justify-center gap-2 ${
              isCancelling ? 'opacity-60' : ''
            }`}
          >
            {isCancelling ? (
              <Spinner />
            ) : (
              translations[language]?.restaurant_menu_cancel_order_accept
            )}
          </button>

          <button
            onClick={onClose}
            disabled={isCancelling}
            className="w-full py-3 text-sm font-medium bg-gray-100 hover:bg-gray-200 text-[#555] border-none rounded-xl cursor-pointer transition-colors duration-200"
          >
            {translations[language]?.restaurant_menu_cancel_order_decline}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderCancelConfirmationModal;
